/* Factory Store — Agregar al carro sin recargar la página.
   Cualquier botón con [data-fs-add="<variant_id>"] agrega 1 unidad por AJAX
   y avisa al tema con el evento 'cart:update' de Horizon: el cart drawer
   se refresca (cart-items-component) y se abre solo (auto_open_cart_drawer),
   y la burbuja del carro actualiza su contador.

   Botones DENTRO del carro abierto (sugerencias): solo se reemplaza el
   contenido del carro. Un morph 'full' del header con el <dialog> abierto lo
   saca de la capa modal y el carro queda "abierto" pero invisible
   (bug 30-sep-2026). */
(function () {
  if (window.__fsAddToCart) return;
  window.__fsAddToCart = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function setState(btn, state, label) {
    if (!btn.isConnected) return;
    btn.classList.remove('is-loading', 'is-done');
    if (state) btn.classList.add(state);
    if (label) btn.textContent = label;
  }

  function cartEvent(cart, sections) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cart,
      sourceId: 'fs-add-to-cart',
      data: { itemCount: cart.item_count, source: 'fs-add-to-cart', sections: sections || {} }
    };
    return ev;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fs-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var original = btn.dataset.fsLabel || btn.textContent.trim();
    btn.dataset.fsLabel = original;
    setState(btn, 'is-loading', 'Agregando…');

    var inCart = btn.closest('cart-items-component');
    var sections = cartSectionIds();

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.fsAdd), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || 'Error');
        var secs = res.data.sections || {};
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (inCart) {
              /* Carro abierto: se reemplaza SOLO el contenido de <cart-items-component>
                 (el <dialog> no se toca, sigue abierto y modal). Los componentes de
                 Horizon recalculan sus refs solos al cambiar sus hijos. El aviso sale
                 desde el propio componente para que no haga su morph completo. */
              var html = secs[inCart.dataset.sectionId];
              if (html) {
                var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items-component');
                if (fresh) {
                  inCart.replaceChildren.apply(inCart, Array.prototype.map.call(fresh.childNodes, function (n) {
                    return document.importNode(n, true);
                  }));
                }
              }
              inCart.dispatchEvent(cartEvent(cart, {}));
              return;
            }
            document.dispatchEvent(cartEvent(cart, secs));
            setState(btn, 'is-done', '✓ Agregado');
            setTimeout(function () { setState(btn, null, original); }, 1800);
          });
      })
      .catch(function (err) {
        setState(btn, null, original);
        var msg = String(err && err.message || '');
        alert(msg && msg !== 'Error' ? msg : 'No pudimos agregar el producto. Intenta de nuevo.');
      });
  });
})();
